import { render, staticRenderFns } from "./backgroundStyle.vue?vue&type=template&id=b49cf082&scoped=true"
import script from "./backgroundStyle.vue?vue&type=script&lang=js"
export * from "./backgroundStyle.vue?vue&type=script&lang=js"
import style0 from "./backgroundStyle.vue?vue&type=style&index=0&id=b49cf082&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b49cf082",
  null
  
)

export default component.exports